export { default as BasicTextEditor } from './Basic'
export { default as FullPageTextEditor } from './FullPage'
